import posthog from 'posthog-js';

// PostHog is here to serve the TREB-220 endpoint rollout flag, not to collect analytics. This is
// a support tool that handles other people's identities, so autocapture and pageview capture stay
// off - turning them on would start logging support-agent behaviour as a side effect of a
// migration. Matches hyble-pwa's AnalyticsProvider, which is configured the same way.
export function initialiseAnalytics(posthogKey, posthogHost) {
  if (!posthogKey || !posthogHost) {
    return;
  }

  // This runs at module scope, before render. An unguarded throw here - a malformed api_host from
  // a bad token replacement, a CSP block, anything internal to the SDK - would take the whole app
  // down, which is a worse failure than the one the flag exists to avoid. Analytics must never be
  // the reason the toolkit does not load.
  try {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      autocapture: false,
      capture_pageview: false,
      capture_dead_clicks: false,
    });
  } catch (error) {
    console.error('PostHog failed to initialise; impersonation will use the existing endpoints.', error);
  }
}
